import React from 'react';
import {Stack, Typography} from '@mui/material';

import Icon from 'presentation/icons';
import {formatPriceBill} from 'presentation/utils';
import {translations} from 'presentation/translations-new';

import type {BillingBeneficiaryItemProps} from '../../types';
import {BeneficiaryName, InfoIconWrapper} from './styles';

const {chargeDetailsAccordion} =
	translations['pt-br'].privateFlow.myFinancial.openBills.detailsDrawer;

function getBeneficiaryLabel(isTitular?: boolean): string {
	if (isTitular) return chargeDetailsAccordion.holderLabel;
	if (isTitular === false) return chargeDetailsAccordion.dependentLabel;
	return '';
}

function BillingBeneficiaryItem({
	item,
	coparticipationLabel,
	onInfoIconClick,
}: BillingBeneficiaryItemProps) {
	const subtotal = item.mensalidade + item.coparticipacao;
	const isShowValueCopart = item.coparticipacao > 0;

	return (
		<Stack gap={0.5}>
			<BeneficiaryName variant="body2" color="text.secondary">
				{item.nome}
				<span style={{textTransform: 'none'}}>{getBeneficiaryLabel(item.isTitular)}</span>
			</BeneficiaryName>
			<Stack direction="row" justifyContent="space-between">
				<Typography variant="body1">{chargeDetailsAccordion.monthlyFee}</Typography>
				<Typography variant="body1">{formatPriceBill(item.mensalidade)}</Typography>
			</Stack>
			{isShowValueCopart && (
				<>
					<Stack direction="row" justifyContent="space-between" alignItems="center">
						<Stack direction="row" alignItems="center" gap={0.5}>
							<Typography variant="body1">{coparticipationLabel}</Typography>
							<InfoIconWrapper
								component="span"
								onClick={event =>
									onInfoIconClick(event.currentTarget as HTMLElement)
								}>
								<Icon name="info-outlined" size={14} />
							</InfoIconWrapper>
						</Stack>
						<Typography variant="body1">
							{formatPriceBill(item.coparticipacao)}
						</Typography>
					</Stack>
					<Stack direction="row" justifyContent="space-between">
						<Typography variant="body1">{chargeDetailsAccordion.subtotal}</Typography>
						<Typography variant="body1" fontWeight={600}>
							{formatPriceBill(subtotal)}
						</Typography>
					</Stack>
				</>
			)}
		</Stack>
	);
}

export {BillingBeneficiaryItem};
